module.exports = __webpack_public_path__ + "static/media/IMG_20191128_143923.fe2e9403.jpg";